import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NeokittyLanding from "./components/NeokittyLanding";
import NeokittyWhitepaper from "./components/NeokittyWhitepaper";
import NeokittyGame from "./components/NeokittyGame";
import NeokittyBuy from "./components/NeokittyBuy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<NeokittyLanding />} />
        <Route path="/:lang" element={<NeokittyLanding />} />

        <Route path="/whitepaper" element={<NeokittyWhitepaper />} />
        <Route path="/:lang/whitepaper" element={<NeokittyWhitepaper />} />

        <Route path="/game" element={<NeokittyGame />} />
        <Route path="/:lang/game" element={<NeokittyGame />} />

        <Route path="/buy" element={<NeokittyBuy />} />
        <Route path="/:lang/buy" element={<NeokittyBuy />} />
      </Routes>
    </Router>
  );
}

export default App;
